import { PostApiClient } from "@/utils/api-client";
import { DataSchema } from "common";

type PostSearchRequest = DataSchema.SearchRequest;
type PostSearchResponse = DataSchema.SearchResponse;

export const postSearchApi = (apiClient: PostApiClient, data: PostSearchRequest) => {
  return apiClient.post<PostSearchResponse>("/api/search", {
    body: JSON.stringify(data),
  });
};

type PostFeedbackRequest = DataSchema.FeedbackRequest;

export const postFeedbackApi = (apiClient: PostApiClient, data: PostFeedbackRequest) => {
  return apiClient.post("/api/search/feedback", {
    body: JSON.stringify(data),
  });
};

type PostSearchDocumentsGoodRequest = {
  ids: string[];
};
type PostSearchDocumentsGoodResponse = DataSchema.DocumentGoodList;

export const postSearchDocumentsGoodApi = (apiClient: PostApiClient, data: PostSearchDocumentsGoodRequest) => {
  return apiClient.post<PostSearchDocumentsGoodResponse>("/api/search/documents/good", {
    body: JSON.stringify(data),
  });
};
